import http from './http'

export default {
  getPage: slug => http.get(`/v2/pages/${slug}`),
  updatePage: (slug, data) => http.put(`/v2/pages/${slug}`, data)
}



// WEBPACK FOOTER //
// ./src/services/api/pages.js